import React, { useEffect, useRef, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link, Redirect } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { CSSTransition } from "react-transition-group";
import ManageDialog from "./manage/manage";
import MenuComp from "./menu.comp";
import SearchIcon from "../../../../components/icons/SearchIcon";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getMenuDatas } from "./menu.config";
import "./header.css";
import { userLogin as sendOtp } from "../../../../pages/auth/login/auth.api";
import SearchModal from "./searchmodal";
import ResetPasswordModal from "./resetPasswordModal";
export default function Header(props) {
  const activelocation = sessionStorage.getItem("active_path");
  let lang = props.state.language;
  const dropdownRef = useRef(null);

  const [openMenu, setOpenMenu] = useState(props.menuState);
  const [searchResults, setSearchResults] = useState([]);
  const [openProfile, setOpenProfile] = useState(props.prof);
  const [openDialog, setOpenDialog] = useState(false);
  const [activeItem, setActiveItem] = useState({});
  const [activeMenu, setActiveMenu] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const words = ["Directory", "Register", "Market Research"];
  const [dynamicWordIndex, setDynamicWordIndex] = useState(0);
  const history = useHistory();
  useEffect(() => {
    setOpenMenu(props.menuState);
  }, [props.menuState]);
  useEffect(() => {
    setOpenProfile(props.prof);
  }, [props.prof]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSearchResults([]);
        setShowSearch(false);
        setSearchQuery("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setDynamicWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [words.length]);

  const handlelanguage = () => {
    let swicthlan = props.state.language === "en" ? "SWITCHMAL" : "SWITCHENG";
    props.setlang(swicthlan);
  };
  const updateBody = (value) => {
    props.setMenu(value);
  };
  const updateProf = (value) => {
    props.setProf(value);
  };
  const closeDialog = () => {
    setOpenDialog(false);
  };
  const handleMenuClick = (e, data) => {
    e.stopPropagation();
    // //console.log(data?.path);
    sessionStorage.setItem("active_path", data.path);
    if (data.next) {
      sessionStorage.setItem("next_path", data.next);
    } else {
      sessionStorage.setItem("next_path", "/dashboard");
    }
    if (data.isDirect) {
      setOpenDialog(false);
      props.history.push(data.path);
    } else {
      setOpenDialog(true);
      setActiveItem(data);
    }
    setOpenMenu(false);
    setActiveMenu(null);
  };
  const handleCloseMenu = () => {
    setOpenMenu(false);
  };
  const handleLogin = () => {
    props.userLogin();
  };

  const handleResetPassword = async () => {
    updateProf(false);
    setShowResetPassword(true);
  };

  const handleSearchToggle = () => {
    setShowSearch(!showSearch);
    setSearchQuery("");
    setSearchResults([]);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    if (query.length > 0) {
      const searchResults = [];

      const searchMenu = (menuItems) => {
        menuItems.forEach((menu) => {
          if (menu?.children?.length > 0) {
            menu.children.forEach((child) => {
              const name = lang === "ma" ? child.label_ma : child.label_en;

              if (name && name.toLowerCase().includes(query)) {
                searchResults.push({
                  id: child.id || Math.random(),
                  name: name,
                  path: child.path || "#",
                });
              }
            });

            searchMenu(menu.children);
          }
        });
      };

      const MenuDatas = getMenuDatas(props.state.isUserAuthenticated);
      if (Array.isArray(MenuDatas)) {
        searchMenu(MenuDatas);
      }

      setSearchResults(searchResults);
    } else {
      setSearchResults([]);
    }
  };

  const handleResultClick = (result) => {
    setSearchQuery(result.name);
    setSearchResults([]);
    setShowSearch(false);
    if (result.path && result.path !== "#") {
      history.push(result.path); 
    }
    setShowSearch(false);
  };

  let userData = props.state.payload ? jwtDecode(props.state.payload) : null;
  return (
    <div className="w-100">
      <div className="container-fluid">
        <div className="row m-auto">
          <div className="col-4  d-flex align-items-center hed-padi">
            <div className="pt-3">
              <div
                className="new-menuIcon-cont"
                onClick={() => {
                  setOpenMenu(!openMenu);
                  updateProf(false);
                  updateBody(!openMenu);
                  setActiveMenu(null);
                }}
              >
                <GiHamburgerMenu
                  onClick={() => {
                    setOpenMenu(!openMenu);
                    updateBody(!openMenu);
                    updateProf(false);
                    setActiveMenu(null);
                  }}
                  className="header-menu-icon menu-cont"
                />
              </div>
              <div className="menu-head-text-cont hideonMobile">
                <div>Menu</div>
              </div>
            </div>
            <div
              className="d-flex align-items-center justify-content-center logo-link"
              onClick={() => {
                setOpenMenu(false);
                props.history.push("/");
              }}
            >
              <div className="hideonMobile">
                <img
                  src="/resources/logo/kg.png"
                  className="header-logo-image-kg"
                  alt="logo"
                />
              </div>
              <div className="hideonMobile d-md-none d-lg-block">
                <div className=" h-100 d-flex align-items-center justify-content-end">
                  <img
                    src="/resources/logo/kit.png"
                    className="kit-logo ml-4"
                    alt="logo"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4  d-flex align-items-center justify-content-center hed-padi pt-2">
            <div
              onClick={() => {
                setOpenMenu(false);
                props.history.push("/");
              }}
              className="d-flex align-items-center h-100 justify-content-center"
            >
              <img
                src="/latest-logo.png"
                className="header-logo-image logo-link h-100 "
                alt="logo"
              />
            </div>
            <div
              onClick={() => {
                setOpenMenu(false);
                props.history.push("/");
              }}
              className="header-title hideonMobileSocial logo-link "
            >
              Kerala Spacepark
            </div>
          </div>

          <div
            className="col-4 d-flex align-items-center justify-content-center "
            onClick={(e) => {
              setOpenMenu(false);
            }}
          >
            <div className="hideonMobileSocial">
              <div className="social-buttons">
                <div
                  href=""
                  onClick={() => {
                    window.open(
                      "https://facebook.com/keralaspacepark",
                      "_blank"
                    );
                  }}
                  className="social-buttons__button social-button social-button--facebook"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </div>
                <div
                  href=""
                  onClick={() => {
                    window.open("https://x.com/keralaspacepark", "_blank");
                  }}
                  className="social-buttons__button social-button social-button--twitter"
                  aria-label="x"
                >
                  <img src="/twitter.png" alt="x" className="twitter_icon" />
                </div>
                <div
                  onClick={() => {
                    window.open(
                      "https://youtube.com/@keralaspacepark",
                      "_blank"
                    );
                  }}
                  className="social-buttons__button social-button social-button--youtube"
                  aria-label="Youtube"
                >
                  <i className="fab fa-youtube"></i>
                </div>
                <div
                  onClick={() => {
                    window.open(
                      "https://instagram.com/keralaspacepark",
                      "_blank"
                    );
                  }}
                  className="social-buttons__button social-button social-button--insta"
                  aria-label="GitHub"
                >
                  <i className="fab fa-instagram"></i>
                </div>
                <div
                  onClick={() => {
                    window.open(
                      "https://linkedin.com/company/keralaspacepark",
                      "_blank"
                    );
                  }}
                  className="social-buttons__button social-button social-button--linkedin"
                  aria-label="Linkedin"
                >
                  <i className="fab fa-linkedin-in"></i>
                </div>
              </div>

            </div>
            <div
              className="d-flex align-items-center"
              // style={{ marginLeft: "26px", gap: "28px" }}
            >
              <div className="lang-container">
                <span
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handlelanguage()}
                >
                  {props.state.language === "en" ? "ML " : "EN"}
                </span>
              </div>

              <div
                className="search-tab searches-icon"
                onClick={handleSearchToggle}
              >
                <SearchIcon />
              </div>

              <div className="login-status-container">
                {!props.state.isValid ? (
                  <div className="new-nav-item ">
                    {props.state.isUserAuthenticated ? (
                      <>
                        <div
                          className="userAvatar"
                          onClick={() => {
                            updateProf(!openProfile);
                          }}
                        >
                          {(() => {
                            const name = userData?.user?.name;
                            if (!name || typeof name !== "string") return "";
                            return name.charAt(0).toUpperCase();
                          })()}
                        </div>
                        <div className="header-profile-title">Profile</div>
                      </>
                    ) : (
                      <>
                        <div
                          className="login-head"
                          onClick={(e) => {
                            handleLogin();
                          }}
                          title="For those registered"
                        >
                          Login
                        </div>
                        <span style={{ fontSize: "9px", color: "gray" }}>
                          For Registered Users
                        </span>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="nav-item ">
                    <div
                      onClick={(e) => {
                        props.logout();
                        props.history.push("/");
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {openMenu && (
        <MenuComp
          {...props}
          handleMenuClick={handleMenuClick}
          userData={userData}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          handleClose={handleCloseMenu}
          auth={props.state.isUserAuthenticated}
        />
      )}
      {openProfile && (
        <div className="new-submenu">
          <div
            className="new-dropdown-item"
            onClick={() => {
              updateProf(false);
              // <Navigate to="/dashboard" />;
              props.history.push("/dashboard");
            }}
          >
            Dashboard
          </div>

          {userData?.multiple && (
            <div
              className="new-dropdown-item"
              onClick={() => {
                updateProf(false);
                props.history.push("/switch-account");
              }}
            >
              Switch Account
            </div>
          )}

          {userData?.user?.is_company_user === true && (
            <div
              className="new-dropdown-item"
              onClick={() => {
                handleResetPassword();
              }}
            >
              Reset Password
            </div>
          )}

          <div
            className="new-dropdown-item"
            onClick={() => {
              updateProf(false);
              props.logout();
              props.history.push("/");
            }}
          >
            Logout
          </div>
        </div>
      )}
      <ManageDialog
        {...props}
        open={openDialog}
        data={activeItem}
        handleClose={closeDialog}
      />
      <SearchModal
        setPaymentOpen={setShowSearch}
        searchResults={searchResults}
        paymentOpen={showSearch}
        handleResultClick={handleResultClick}
        searchQuery={searchQuery}
        handleSearchChange={handleSearchChange}
        showSearch={showSearch}
      />
      <ResetPasswordModal
        show={showResetPassword}
        onHide={() => setShowResetPassword(false)}
        token={props.state?.payload}
      />
    </div>
  );
}
